export const tiposPagamento = [
    { id: "3EF7CAA0-AF73-440C-801B-2B5788E69C37", descricao: "PRODUTIVIDADE" },
    { id: "BE21DBC5-6C12-47B0-8C02-3D92111B3379", descricao: "SUPERAÇÃO" },
    { id: "D139F68F-6E22-46E4-B5D4-268D31FC9ECC", descricao: "REPASSE" },
]

export const tipoRegraValor = {
    "3EF7CAA0-AF73-440C-801B-2B5788E69C37": "valorProdutividadeOriginal",
    "BE21DBC5-6C12-47B0-8C02-3D92111B3379": "valorSuperacaoOriginal",
    "D139F68F-6E22-46E4-B5D4-268D31FC9ECC": "valorComissaoPagaOriginal",
}

export const statusSelecionaveis = [
    "5fd35513-c165-40ec-be20-fb1dcf2fc671",
    "ceca981e-9068-47c5-8735-c9677d2d12f2",
]
